import { render } from "./IconEcosystem.vue?vue&type=template&id=6da7f04a"
import script from "./IconEcosystem.vue?vue&type=script&lang=js"
export * from "./IconEcosystem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__